import request from '@/utils/request'

export function getCredit(bankholder_id){
  return request({
    url: `/api/monthlyfeecredits/${bankholder_id}`,
    method: "get"
  });
}


export function getCreditBalance(bankholder_id){
  return request({
    url: `/api/monthlyfeecredits/${bankholder_id}/balance`,
    method: "get"
  });
}

export function addCredit(bankholder_id, data){
  return request({
    url: `/api/monthlyfeecredits/${bankholder_id}`,
    method: "post",
    data: data
  })
}

export function getCreditRecord(uid){
  return request({
    url: `/api/monthlyfeecredits/record/${uid}`,
    method: "get"
  });
}

export function updateCreditRecord(uid, data){
  return request({
    url: `/api/monthlyfeecredits/record/${uid}`,
    method: "put",
    data: data
  });
}

export function deleteCreditRecord(uid){
  return request({
    url: `/api/monthlyfeecredits/record/${uid}`,
    method: "delete"
  });
}